import {
  alpha,
  IconButton,
  Tooltip,
  type IconButtonProps,
} from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useThemeMode } from '@/context/themeMode';

type ThemeModeToggleProps = Pick<IconButtonProps, 'size' | 'sx'> & {
  onBrandSurface?: boolean;
};

const ThemeModeToggle = ({
  onBrandSurface = false,
  size = 'small',
  sx,
}: ThemeModeToggleProps) => {
  const { mode, toggleMode } = useThemeMode();
  const targetMode = mode === 'light' ? 'dark' : 'light';

  return (
    <Tooltip title={`Switch to ${targetMode} mode`}>
      <IconButton
        size={size}
        aria-label={`Switch to ${targetMode} mode`}
        aria-pressed={mode === 'dark'}
        onClick={toggleMode}
        sx={[
          (theme) => ({
            width: 36,
            height: 36,
            color: onBrandSurface
              ? theme.palette.common.white
              : theme.palette.text.secondary,
            bgcolor: onBrandSurface
              ? 'transparent'
              : theme.palette.background.paper,
            border: `1px solid ${
              onBrandSurface
                ? alpha(theme.palette.common.white, 0.18)
                : theme.palette.divider
            }`,
            '&:hover': {
              bgcolor: onBrandSurface
                ? alpha(theme.palette.common.white, 0.1)
                : theme.palette.action.hover,
            },
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {mode === 'light' ? (
          <DarkModeOutlinedIcon fontSize="small" />
        ) : (
          <LightModeOutlinedIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeModeToggle;
